import { useState } from "react";
import Form from "react-bootstrap/Form";
import InputGroup from "react-bootstrap/InputGroup";
import { useTranslation } from "react-i18next";

const SearchForm = () => {
    const [expand, setExpand] = useState(false);
    const [t] = useTranslation("global");
    return (
        <Form
            inline
            className={`search-form ${expand && "expand"}`}
            onMouseEnter={() => setExpand(true)}
            onMouseLeave={() => setExpand(false)}
        >
            <InputGroup>
                <InputGroup.Text id="search">
                    <div className="search-svg"></div>
                </InputGroup.Text>
                <Form.Control
                    className="search-input"
                    type="text"
                    placeholder={t("nav.search")}
                    aria-label={t("nav.search")}
                    aria-describedby="search"
                />
            </InputGroup>
        </Form>
    );
};

export default SearchForm;
